import { cn } from "@/utils/cn";

// Centered content wrapper with consistent horizontal padding.
export const Container = ({ className = "", children, ...props }) => (
  <div className={cn("max-w-7xl mx-auto px-5 md:px-8", className)} {...props}>
    {children}
  </div>
);
